import * as React from 'react';
import { VFFieldProps } from '../types';
import classNames from 'classnames';
import * as Classes from '../../common/classes';
import { StringInput } from '../../string/StringInput';
import { ReactNode } from 'react';
import { FormGroup } from '../../form-group/FormGroup';

export type ValueDetailComponentProps = Omit<
  VFFieldProps<React.ComponentProps<typeof StringInput>> & {
    /**
     * Hodnota pro zobrazení.
     */
    value?: ReactNode;
  },
  'name' | 'label' | 'inputClassName'
> & {
  label?: React.ReactNode;
  emptyLabel?: boolean;
};

type FormDetailComponentProps = {};
const FormDetailComponent: React.FC<FormDetailComponentProps> = ({
  children,
}) => {
  return (
    <div className={classNames(Classes.FORM_DETAIL_COMPONENT)}>{children}</div>
  );
};

export const DetailComponent = React.forwardRef<
  HTMLInputElement,
  ValueDetailComponentProps
>(
  (
    {
      className,
      label,
      emptyLabel,
      value,
      // disabled,
      inlineValidation,
      // ...other
    }
    // ref
  ) => {
    const cls = classNames(
      Classes.FORM_GROUP,
      Classes.FORM_GROUP_FORM,
      Classes.RF_FORM_GROUP,
      className,
      {
        [Classes.RF_NO_ERROR_SPACE]: inlineValidation,
      }
    );

    return (
      <FormGroup
        // ref={ref}
        className={cls}
        label={label}
        emptyLabel={emptyLabel}
        contentClassName={'align-items-center'}
      >
        <FormDetailComponent>{value}</FormDetailComponent>
      </FormGroup>
    );
  }
);
